import Pusher from 'pusher-js'
import Events from '@/utils/events'
import Store from '@/store'
import { API, PUSHER } from '@/config'

let CHATS = {}

export default {
	connect() {
		let token = localStorage.getItem('lapka:token')
		if (!token) return

		if (this.connected) return
		this.connected = true

		let pusher = new Pusher(PUSHER.key, {
			wsHost: PUSHER.host,
			authEndpoint: PUSHER.authEndpoint,
			forceTLS: true,
			enabledTransports: ['ws', 'wss'],
			auth: {
				headers: { Token: token },
			},
		})

		let updateToken = () => {
			token = localStorage.getItem('lapka:token')
			if (!token) return
			pusher.config.auth.headers = { Token: token }
		}

		pusher.connection.bind('disconnected', updateToken)
		Events.$on('token-changed', updateToken)

		// events
		let admin = pusher.subscribe('private-admin')

		admin.bind('chatMessage', e => Events.$emit('chatMessage', e))
		admin.bind('fetchTicket', e => Events.$emit('fetchTicket', e))
		admin.bind('fetchCall', e => Events.$emit('fetchCall', e))
		admin.bind('updateChatAndTicket', e =>
			Events.$emit('updateChatAndTicket', e)
		)
		admin.bind('deleteChatAndTicket', e =>
			Events.$emit('deleteChatAndTicket', e)
		)
		admin.bind('callMutation', e => Events.$emit('callMutation', e))
		admin.bind('syncPetEvents', e => Events.$emit('syncPetEvents', e))

		admin.bind('fetchOrder', e => Events.$emit('fetchOrder', e))
		admin.bind('removeOrder', e => Events.$emit('removeOrder', e))

		admin.bind('startTyping', e => Events.$emit('startTyping', e))
		admin.bind('stopTyping', e => Events.$emit('stopTyping', e))

		admin.bind('chatUpdateMessage', e => Events.$emit('chatUpdateMessage', e))
		admin.bind('chatDeleteMessage', e => Events.$emit('chatDeleteMessage', e))

		admin.bind('chatUpdateReadBy', e => Events.$emit('chatUpdateReadBy', e))

		this.pusher = pusher
	},

	subscribe(channel) {
		return this.pusher.subscribe(channel)
	},

	disconnect() {
		if (this.pusher) this.pusher.disconnect()
		this.connected = false
	},
}
